import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DatosSubidaService } from 'src/app/pages/subidaPrincipal/services/datos-subida.service';


@Component({
  selector: 'app-avance-subida',
  templateUrl: './avance-subida.component.html',
  styleUrls: ['./avance-subida.component.css']
})
export class AvanceSubidaComponent implements OnInit {

  @Output()linkClicked:EventEmitter<boolean> = new EventEmitter<boolean>();
  constructor(public datosSubidaService:DatosSubidaService) { }

  ngOnInit(): void {
  }

  get avance(){
    const avanceReal = this.datosSubidaService.datosProcesoServidor.avanceProceso;
    // if (this.datosSubidaService.datosProcesoServidor.total === 0 && avanceReal === 0) {
    //   return '5%';
    // }
    return `${avanceReal.toFixed(2)}%`
  }
  get mensajeCompletado(){
    return 'Completada'

  }

  get mensajeProcesando(){
    if (this.datosSubidaService.datosProcesoServidor.total === 0) {
      return 'Iniciando procesamiento...';
    }
    return `Procesando ${this.datosSubidaService.datosProcesoServidor.procesados} de ${this.datosSubidaService.datosProcesoServidor.total }`

  }
  iraDetalle(){
    this.linkClicked.emit(true);
  }

}
